// extracted by mini-css-extract-plugin
export default {"dashboard-page":"DashboardPage_dashboard-page__ULHXg","dashboard-page-main":"DashboardPage_dashboard-page-main__nkk3M","search-bars":"DashboardPage_search-bars__OL4Hr"};